import ButtonGroupActions from '@/components/ButtonGroupActions'
import SubHeaders from '@/components/Headers/SubHeaders'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { useTourHandler } from '@/contexts/tour-handler'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { generatePathDatacentral, paths } from '@/utils/path'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { getInvoiceByInvoiceId } from '../../services'
import EInvoiceSection from '../EInvoice/EInvoiceSection'
import { useEInvoiceAccess } from '../../hooks/use-e-invoice-access'
import InvoiceCommissionSection from './InvoiceCommissionSection'
import InvoiceInfoSection from './InvoiceInfoSection'
import ListInvoiceItem from './ListInvoiceItem'
import ListInvoiceUpdate from './ListInvoiceUpdate'
import MailHistory from './MailHistory'
import List from './Transactions/List'
import { useInvoiceDetailActions } from '../../hooks/use-invoice-detail-actions'
import { useInvoiceDetailTour } from '../../hooks/use-invoice-detail-tour'

const Detail = () => {
    const { id } = useParams()
    const { t } = useTranslation()
    const invoiceId = Number(id)
    const { startTour } = useInvoiceDetailTour()
    const { registerHandler, unregisterHandler } = useTourHandler()

    useEffect(() => {
        registerHandler(startTour)
        return () => unregisterHandler()
    }, [registerHandler, unregisterHandler, startTour])

    const { data, renderState } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.INVOICE_DETAIL, invoiceId],
        queryFn: () => getInvoiceByInvoiceId(invoiceId),
    })

    const invoice = data?.result
    const { actions } = useInvoiceDetailActions({ invoiceId, invoice })
    const { canView: canViewEInvoice } = useEInvoiceAccess()

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    return (
        <div className="space-y-2">
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    { path: paths.invoices, title: t('invoices') },
                    {
                        path: generatePathDatacentral(paths.invoiceDetail, {
                            id: id,
                        }),
                        title: `#${id}`,
                    },
                ]}
            />
            <ButtonGroupActions actions={actions} className="rounded-sm" />

            {invoice && (
                <InvoiceInfoSection invoice={invoice} invoiceId={invoiceId} />
            )}

            {/* Chỉ nhóm Kế toán / BOM / BOD / Admin mới thấy hoá đơn điện tử */}
            {invoice && canViewEInvoice && (
                <EInvoiceSection
                    invoiceID={invoiceId}
                    invoiceStatus={invoice.invoice_status}
                    invoiceTotal={invoice.invoice_total}
                    invoicable={invoice.invoicable}
                />
            )}

            {invoice && <InvoiceCommissionSection invoice={invoice} />}

            <div data-tour="invoice-items">
                <ListInvoiceItem
                    data={{
                        customer: invoice?.customer,
                        service_id: invoice?.service_id,
                        invoice_status: invoice?.invoice_status,
                        invoice_amount: invoice?.invoice_amount,
                        invoice_vat: invoice?.invoice_vat,
                        invoice_total: invoice?.invoice_total,
                    }}
                />
            </div>
            <div data-tour="invoice-updates">
                <ListInvoiceUpdate />
            </div>
            <div data-tour="invoice-transactions">
                <List invoiceID={invoiceId} />
            </div>
            <div data-tour="invoice-mail-history">
                <MailHistory invoiceId={invoiceId} />
            </div>
        </div>
    )
}

export default Detail
